import Link from 'next/link';
import Image from 'next/image';
import xw from 'xwind';

import ListTile from '@/components/ListTile';
import { Resource } from '@/types/Content/Resources';
import { css } from '@emotion/react';
import { ContentType } from '@/common/constants/ContentTypes';
import { color } from 'theme.material';

type BlogPostTileProps = Pick<
  Resource,
  'title' | 'image' | 'resourceType' | 'slug'
> & { bgColor?: string; className?: string };

function BlogPostTile({
  title,
  image,
  resourceType,
  slug,
  bgColor,
  className,
}: BlogPostTileProps): JSX.Element {
  const { url, alt } = image ?? {};
  const articlePath = `/${ContentType.RESOURCES}/${slug}`;

  return (
    <Link href={articlePath}>
      <a>
        <ListTile bgColor={bgColor} className={className}>
          {url && (
            <Image
              src={url}
              alt={alt}
              layout="fill"
              objectFit="cover"
              unoptimized
            />
          )}
          <ListTile.Content>
            <ListTile.Title>{title}</ListTile.Title>

            <ListTile.IconContainer>
              {resourceType?.iconUrl && (
                <Image
                  src={resourceType.iconUrl}
                  height="32"
                  width="32"
                  layout="intrinsic"
                />
              )}
            </ListTile.IconContainer>
          </ListTile.Content>
        </ListTile>
      </a>
    </Link>
  );
}
BlogPostTile.defaultProps = {
  bgColor: color.grey[100],
  className: null,
};
export default BlogPostTile;
